<template>
  <div v-if="isShow" class="exception-page">
    <div class="img">
      <img src="https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg" />
    </div>
    <div class="content">
      <h1>此功能已升级</h1>
      <div class="desc">请前往新系统使用</div>
      <div class="action">
        <a-button type="primary" @click="goNewVersion">体验新版</a-button>
      </div>
    </div>
  </div>
</template>

<script>

import env from "../../../env";

export default {
  name: 'NewVersionPage',
  data () {
    return {
      isShow: false
    }
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    if (!window.__POWERED_BY_WUJIE__) {
      this.isShow = true
    }
  },
  methods: {
    goNewVersion() {
      window.open(env.NEW_SYSTEM_URL);
    }
  }
}
</script>

<style lang="less" scoped>
.exception-page{
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: @base-bg-color;
  padding: 100px 0;
  .img{
    padding-right: 52px;
    zoom: 1;
    img{
      max-width: 430px;
    }
  }
  .content{
    h1{
      color: #434e59;
      font-size: 36px;
      font-weight: 600;
      line-height: 72px;
      //margin-bottom: 24px;
    }
    .desc{
      color: @text-color-second;
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
}

</style>
